import { useTranslation } from "react-i18next";

import type { UseTransientScenariosReturn } from "../hooks/useTransientScenarios";
import type { ScenarioDefinitionFormState } from "../model/transientScenario";

import { SCENARIO_COLUMN_CLASS_NAME } from "../lib/transientForm";
import { ConfigurationSwitchRow } from "./ConfigurationSwitchRow";
import { TransientNumericFieldRow } from "./TransientNumericFieldRow";

type ScenarioSwitchColumnProps = {
  scenario: ScenarioDefinitionFormState;
  scenariosState: UseTransientScenariosReturn;
};

const SCENARIO_SWITCH_LABEL_CLASS_NAME = "w-[12rem]";

export const ScenarioSwitchColumn = ({ scenario, scenariosState }: ScenarioSwitchColumnProps) => {
  const { t } = useTranslation();
  const { updateScenario } = scenariosState;

  return (
    <div className={SCENARIO_COLUMN_CLASS_NAME}>
      <ConfigurationSwitchRow
        checked={scenario.measured_weather_data}
        label={t("Execution.transient.scenario.measuredWeatherData")}
        onChange={(value) => updateScenario(scenario.id, { measured_weather_data: value })}
      />
      <ConfigurationSwitchRow
        checked={scenario.t_supply_dynamic}
        label={t("Execution.transient.scenario.tSupplyDynamic")}
        onChange={(value) => updateScenario(scenario.id, { t_supply_dynamic: value })}
      />
      <ConfigurationSwitchRow
        checked={scenario.detailed_simulation_needed}
        label={t("Execution.transient.scenario.detailedSimulation")}
        onChange={(value) => updateScenario(scenario.id, { detailed_simulation_needed: value })}
      />
      <TransientNumericFieldRow
        label={t("Execution.transient.configuration.requiredTMax")}
        labelClassName={SCENARIO_SWITCH_LABEL_CLASS_NAME}
        onChange={(requiredTMax) => updateScenario(scenario.id, { requiredTMax })}
        value={scenario.requiredTMax}
      />
    </div>
  );
};
